import {API} from "aws-amplify";

export const TransferAPI = {
    fetchTransferDetails: (transferId) => API.get("transfers", `/get-full/id/${transferId}`, {})
}